import {
  type GetWorkerRequirementsResponse,
  WorkerRequirementMappingLevel,
  WorkerRequirementStatus,
} from "@clipboard-health/contract-worker-app-bff";
import { type UseInfiniteGetQueryOptions } from "@src/appV2/api/useInfiniteGetQuery";
import { type AxiosError } from "axios";

import { type WorkerRequirement } from "../types";
import { useGetPaginatedWorkerRequirements } from "../useGetPaginatedWorkerRequirements";
import { requirementRelationship } from "../useGetWorkerRequirements";

interface UseGetIncompleteWorkplaceSpecificRequirementsProps {
  qualifications: string[];
}

export function useGetIncompleteWorkplaceSpecificRequirements(
  props: UseGetIncompleteWorkplaceSpecificRequirementsProps,
  options: UseInfiniteGetQueryOptions<
    GetWorkerRequirementsResponse,
    AxiosError,
    WorkerRequirement[]
  > = {}
) {
  const { qualifications } = props;

  return useGetPaginatedWorkerRequirements(
    {
      filter: {
        qualifications,
        requiredForBooking: true,
        levels: [WorkerRequirementMappingLevel.HCF],
        status: { not: [WorkerRequirementStatus.APPROVED] },
        visibleToWorker: true,
      },
      include: [...requirementRelationship],
      page: { size: 10 },
    },
    options
  );
}
